import script from "./VerifyCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyCompleted.vue?vue&type=script&setup=true&lang=js"

import "./VerifyCompleted.vue?vue&type=style&index=0&id=a556540a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a556540a"]])

export default __exports__